import * as React from "react";
import * as angular from "angular";
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { connect } from 'react-redux';
import { default as reducers } from '../state/associationsReducers';
import AssociationCreator from './creator/AssociationCreator';
import AssociationsMap from './AssociationsMap';
import {
    selectContract,
    requestAssociations,
    RequestAssociations,
    SelectContract,
    RequestContract,
    requestContract
} from "../../../actions/actions";
import server from "../../../../integration/server/server-services";
import datacatalog from "../../../../integration/datacatalog/datacatalog-services";
import nvdbapi from "../../../../integration/nvdbapi/nvdbapi";
import { ServerHolder } from "../../contract-features-3/components/ContractFeatures";
import security from "../../../../service/security/security-services";
import contractService from "../../../../service/contract/contract-services";
import AssociationTree from "./AssociationTree";
import AssociationsState from "../state/AssociationsState";

const serverHolder = new ServerHolder();
const store = createStore(reducers, applyMiddleware(thunk.withExtraArgument(serverHolder)));

interface ContractAssociationsViewProps {
    selectContract: SelectContract;
    requestAssociations: RequestAssociations;
    contractId: string;
    isInitializing: boolean;
    isFetching: boolean;
    requestContract: RequestContract;
}

class ContractAssociationsView extends React.Component<ContractAssociationsViewProps, { isLoading: boolean }> {
    constructor(props: ContractAssociationsViewProps) {
        super(props);
        this.state = { isLoading: true };
    }

    async componentDidMount() {
        const { contractId } = this.props;

        this.setState({ isLoading: true });

        serverHolder.contract.contractId = contractId;

        this.props.requestContract(contractId);
        this.props.selectContract(contractId);
        this.props.requestAssociations(contractId);

        try {
            await serverHolder.contract.readFeatureList();
        } catch (error) {
            console.error("Error during initialization:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        return (
            <div id="associations-container">
                <AssociationTree loading={this.state.isLoading} />
                <AssociationCreator />
                <div id="association-map-container">
                    <AssociationsMap />
                </div>
            </div>
        );
    }
}

interface ContractAssociationsProps {
    $routeParams: angular.route.IRouteParamsService;
    server: server;
    security: security;
    contract: contractService;
    nvdbapi: nvdbapi;
    datacatalog: datacatalog;
}

const mapStateToProps = (state: AssociationsState, ownProps: any) => {
    const contractId = ownProps.contractId;
    return {
        contractId: contractId,
        isInitializing:
            !state.isFetching &&
            (state.contractId !== contractId || !state.contractId),
        isFetching: !!state.user && state.isFetching,
    };
};

const mapDispatchToProps = {
    selectContract,
    requestAssociations,
    requestContract,
};

const ConnectedContractAssociationsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(ContractAssociationsView);

export class ContractAssociations extends React.Component<ContractAssociationsProps, {}> {
    render() {
        const { server, security, contract, nvdbapi, datacatalog } = this.props;

        serverHolder.server = server;
        serverHolder.security = security;
        serverHolder.contract = contract;
        serverHolder.nvdbapi = nvdbapi;
        serverHolder.datacatalog = datacatalog;

        const contractId = this.props.$routeParams["contractId"];

        return (
            <Provider store={store} key="provider">
                <ConnectedContractAssociationsView contractId={contractId} />
            </Provider>
        );
    }
}